import api from "Common/Client/Interceptor";

export const fetchTrainingGroup = async (learnerId, token) => {
  try {
    const response = await api.get(
      `/TrainingGroup/Learner/List?LearnerId=${learnerId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};